import { render, staticRenderFns } from "./Universo.vue?vue&type=template&id=8bb2a6ca"
import script from "./Universo.vue?vue&type=script&lang=js"
export * from "./Universo.vue?vue&type=script&lang=js"
import style0 from "./Universo.vue?vue&type=style&index=0&id=8bb2a6ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports